// extracted by mini-css-extract-plugin
export default {"popover":"styles__popover___9n94c","triggerButton":"styles__triggerButton___VormM","menu":"styles__menu___vmMKW","menuItem":"styles__menuItem___vkjIG"};